import { getCategoricalColor } from "../../../../utils/categoricalColorScale";
import { getContrastColorFromRgba } from "../../../../utils/contrastColor";
import { breaks, generalStatistics } from "./utilities";
// Takes the data [values] from categorical observation records
// and the aggregationType (e.g., avg, median, most_recent, or total)
// then outputs a legend object with ranges and colors

// "options": [
// {
//     "id": 8048,
//     "value": "0",
//     "orderNumber": 1
// },
// {
//     "id": 8047,
//     "value": "1",
//     "orderNumber": 2
// }
// ]

export function legendCategoricalData(options = [], values = []) {
  console.log("Generating categorical data legend");

  // determine the character length of the longest category for layout purposes
  const maxCharacters =
    options.length === 0
      ? null
      : Math.max(...options.map((option) => String(option.value).length));
  const useFullValues = maxCharacters !== null && maxCharacters <= 4;

  let ranges = [];
  for (let i = 0; i < options.length; i++) {
    const category = options[i];

    const backgroundColor = getCategoricalColor(i, options.length);
    const contrastColor = getContrastColorFromRgba(backgroundColor);

    // use full category value if it is short enough, otherwise
    //  use A, B, C, ....,  AA, AB etc.
    const textSymbol = () => {
      if (useFullValues) {
        return category.value;
      } else {
        // convert index to letters
        let index = i;
        let letters = "";
        do {
          letters = String.fromCharCode((index % 26) + 65) + letters;
          index = Math.floor(index / 26) - 1;
        } while (index >= 0);
        return letters;
      }
    };
    // adjust symbol font size based on length
    // minimum of 6 when string is long, max of 14 for short strings
    const fontSize = Math.max(
      6,
      Math.min(14, 14 - (textSymbol().length - 1) * 3),
    );

    // count how many locations have this option/category id
    const locationCount =
      values && values.length > 0
        ? values.filter((v) => v === category.id).length
        : 0;

    ranges.push({
      text: category.value,
      symbol: {
        type: null,
        size: fontSize,
        text: textSymbol(),
      },
      category: category,
      color: contrastColor,
      backgroundColor: backgroundColor,
      locationCount: locationCount,
    });
  }

  let legend = {
    scale: "categorical",
    min: null,
    max: null,
    wholeNumber: false,
    useFullValues: useFullValues,
    maxCharacters: maxCharacters,
    ranges: ranges,
  };

  return legend;
}
